//interfaces
import { ISimpleRow } from "../../../../../../interfaces/simpleTable";

//hooks
import SimpleTableMenu from "../SimpleTableMenu/SimpleTableMenu";



const SimpleRow = ({row, isHighlightedRow, rowIndex, setControlIndex, isControlIndex, hasControlsColumn}: ISimpleRow) => {
    const hasControls: boolean = row.controls?.some(control => control.content !== undefined) ?? false;
    return (
        <tr className={`simple-row  ${isHighlightedRow ? "highlighed-row-style" : ""}`}>
            {row.content.map((cell: any, cellIndex: number) => (
                <td key={rowIndex-cellIndex}>{cell}</td>
            ))}

            {hasControls 
                ? (<SimpleTableMenu isControlIndex={isControlIndex} setControlIndex={setControlIndex} buttons={row.controls || <></>} />)
                : hasControlsColumn && <td />}
        </tr>
    );
};

export default SimpleRow;